var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v(_vm._s(_vm.pageTitle))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit", id: "BackBtn" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c("div", { staticClass: "row no-margin" }, [
              _c("div", { staticClass: "col-12 forms-block" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.title,
                          expression: "title"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        maxlength: "190",
                        type: "text",
                        id: "dayForceId",
                        placeholder: "Enter Folder Name"
                      },
                      domProps: { value: _vm.title },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.title = $event.target.value
                          },
                          function($event) {
                            _vm.titleError = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.titleError))
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "row clearfix" }),
            _vm._v(" "),
            _c("input", {
              staticClass: "ml-2 btn btn-primary pull-right",
              attrs: { id: "addBenifitBtn", type: "submit", value: "Save" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addUpdateManagerToolBox((_vm.flag = "Save"))
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              staticClass: "ml-2 btn btn-primary pull-right",
              attrs: {
                id: "addAndContinueBenifitBtn",
                type: "submit",
                value: "Save and Continue"
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addUpdateManagerToolBox(
                    (_vm.flag = "Save and Continue")
                  )
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              staticClass: "ml-2 back_button btn btn-primary pull-right",
              attrs: { id: "CancelBenifit", type: "submit", value: "Cancel" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "dayForceId" } }, [
        _vm._v("Folder Name :")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d58e634c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d58e634c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/ManagerToolBox/AddUpdateFolder.vue
// module id = null
// module chunks = 